<template lang="pug">
  .dashboard-inner.narrow-modal-body
    SectionTitle(:text="modalTitle" data-mr-ass="add-payment-method-modal").app-modal-title
    form

    .amazon-pay(v-if="editingAmazon")
      .edit(v-if="validAmazonSession")
        AmazonPayWidget
        ThirdPartyProfileDefaults(:done-method="onCancel")

      .init(v-else)
        p.mb-15 To edit your Amazon billing info:
        AmazonPayButton

    .paypal-edit(v-if="editingPaypal")
      PaymentProfile(:profile="editProfileForm")
      ThirdPartyProfileDefaults(:done-method="onCancel")

    form(v-if="!editProfileForm.paymentGateway || editProfileForm.paymentGateway == 'braintree'")
      .row
        PaymentEditInputs(:v="$v")

      .row(v-if="!editProfileForm.same_as_shipping")
        AddressEditInputs(:v="$v")

      .row
        SubmitButtons(
          submit-text="Save"
          :submit-method="onSubmit"
          :submit-disabled="savingProfile"
          cancel-text="Cancel"
          :cancel-method="onCancel"
        )

</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  import PaymentEditInputs from "./PaymentEditInputs";
  import SubmitButtons from "../SubmitButtons";
  import AddressEditInputs from "../AddressBook/AddressEditInputs";
  import SectionTitle from "../SectionTitle";
  import ThirdPartyProfileDefaults from "./ThirdPartyProfileDefaults";
  import PaymentProfile from "./PaymentProfile";
  import AmazonPayButton from "./AmazonPayButton";
  import AmazonPayWidget from "./AmazonPayWidget";

  export default {
    name: "PaymentEditModal",
    components: {
      AmazonPayButton,
      AmazonPayWidget,
      PaymentProfile,
      ThirdPartyProfileDefaults,
      SectionTitle,
      PaymentEditInputs,
      AddressEditInputs,
      SubmitButtons
    },

    beforeCreate() {
      //- need subs when/if updating payment for all subs
      this.$store.dispatch('subscriptions/initSubscriptions');
    },

    computed: {
      ...mapState('payments', [
        'savingProfile',
        'editProfileForm',
        'profileFormValidators',
        'validAmazonSession'
      ]),

      ...mapState('modal', ['visible']),

      ...mapState('addressBook', [
        'editAddressForm',
        'addressFormValidators'
      ]),

      //- needed for address validation when shipping is not the same as billing
      ...mapGetters('addressBook', [
        'paymentEditAddressValidator'
      ]),

      modalTitle() {
        return `${this.editProfileForm.paymentProfileId ? 'Edit' : 'Add'} Payment Method`;
      },

      editingAmazon() {
        return this.editProfileForm.paymentGateway == 'amazon';
      },

      editingPaypal() {
        return this.editProfileForm.paymentGateway == 'paypal';
      }
    },

    methods: {
      ...mapActions('payments', [
        'saveProfileForm',
        'clearEditProfileForm'
      ]),

      ...mapActions('addressBook', [
        'clearEditAddressForm'
      ]),

      ...mapActions('modal', ['hideModal']),

      ...mapMutations('payments', [
        'setValidAmazonSession'
      ]),

      onSubmit() {
        //- validate addressForm first,
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.saveProfileForm().then(() => {
          this.$emit('hide-modal');
        });
      },

      onCancel() {
        this.hideModal();
        this.cleanUp();
      },

      cleanUp() {
        this.clearEditProfileForm();
        this.clearEditAddressForm();
        //- if user gets here and has editPayment we pop the edit payment modal,
        //- upon close or submit lets clear the params so this modal does not pop again
        if (this.$route.query['editPayment']) {
          const currentPath = this.$route.path;
          this.$router.replace({path: currentPath, query: {}});
        }
      }
    },

    validations() {
      var validations = {
        editProfileForm: this.profileFormValidators
      };

      if (this.editProfileForm.paymentProfileId) {
        delete validations.editProfileForm.cc_number.required;
        delete validations.editProfileForm.cc_cvc.required;
      }

      if (!this.editProfileForm.same_as_shipping) {
        validations.editAddressForm = this.paymentEditAddressValidator;
      }

      if (this.editingAmazon || this.editingPaypal) {
        validations = {};
      }

      return validations;
    },

    beforeDestroy() {
      if (!this.visible) {
        this.cleanUp();
      }
    }
  }
</script>

<style scoped lang="stylus">
  .amazon-pay
    .edit
    .init
      text-align center
      margin-bottom 2em

</style>